import React from 'react';
import { Route, Switch } from 'react-router-dom';

import { route as routePropType } from 'common/propTypes';
import NotFound from 'common/components/NotFound';
import OffRampPage from './OffRamp';
import NewOffRampPage from './NewOffRamp';
import OffRampDetailPage from './OffRampDetail';

const Routes = ({ match }) => (
  <Switch>
    <Route exact path={`${match.path}/new`} component={NewOffRampPage} />
    <Route exact path={`${match.path}/:id`} component={OffRampDetailPage} />
    <Route exact path={match.path} component={OffRampPage} />
    <Route component={NotFound} />
  </Switch>
);

Routes.propTypes = routePropType;

export default Routes;
